<template lang="pug">

  .email-verification-component(v-if="checked")
    .success(v-if="success")
      slot(name="success") {{ successMessage || $t('email_verification.succeeded') }}
    .error(v-else="")
      slot(name="error") {{ failureMessage || $t('email_verification.failed') }}

</template>

<script>
import axios from 'axios';
const EventBus = window.VueEventBus

export default {
  name: 'email-verification',

  props: ['token', 'email', 'successMessage', 'failureMessage'],

  data: () => ({
    checked: false,
    success: true
  }),
  
  async created() {
    EventBus.$emit('email-verification.init', this.email)
    try {
        await axios.post(`${window.addiesaas.url}/api/user/email-verification/check`, {
          token: this.token,
          email: this.email
        });
        EventBus.$emit('email-verification.success', this.email)
    } catch (e) {
        this.success = false;
        EventBus.$emit('email-verification.failed', e, this.email)
    }
    this.checked = true;
    EventBus.$emit('email-verification.end', this.email)
  },
}
</script>
